import React from 'react'
import { withRouter } from 'react-router'
import Login from '../../containers/Login'
import Signup from '../../containers/Signup'
import { isLogin } from '../../utils/index'

class RequireLogin extends React.Component {
  state = {
    showLogin: !isLogin(),
    showSignup: false
  }
  render() {
    return (
      <React.Fragment>
        <Login
          open={this.state.showLogin}
          onClose={() => this.setState({ showLogin: false })}
          toggleSignup={() => {
            this.setState({ showLogin: false })
            this.setState({ showSignup: true })
          }}
        />
        <Signup
          open={this.state.showSignup}
          onClose={() => this.setState({ showSignup: false })}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(RequireLogin)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/RequireLogin/index.js